export type PhotoSubmissionStatus = 'pending' | 'approved' | 'rejected';

export type PhotoSubmissionFilter = 'all' | PhotoSubmissionStatus;

export type PhotoSubmissionModel = {
  id: string;
  photoUrl?: string | null;
  caption?: string | null;
  createdAt: string;
  approved?: boolean | null;
  user?: { id?: string | null; name?: string | null } | null;
  userId?: string | null;
  possibleBannedDevice?: boolean | null;
  matchedBanCreatedAt?: string | null;
};

export function getPhotoSubmissionStatus(
  approved?: boolean | null,
): PhotoSubmissionStatus {
  if (approved === true) return 'approved';
  if (approved === false) return 'rejected';
  return 'pending';
}

export function matchesPhotoSubmissionFilter(
  status: PhotoSubmissionStatus,
  filter: PhotoSubmissionFilter,
): boolean {
  return filter === 'all' || status === filter;
}

export function photoSubmissionStatusLabel(
  status: PhotoSubmissionStatus,
): string {
  if (status === 'approved') return 'Approved';
  if (status === 'rejected') return 'Rejected';
  return 'Pending';
}

export function canApprovePhoto(
  submission: Pick<PhotoSubmissionModel, 'approved' | 'possibleBannedDevice'>,
  requireApproval: boolean,
): boolean {
  return (
    (submission.possibleBannedDevice ||
      (requireApproval && submission.approved !== true) ||
      submission.approved === false) &&
    submission.approved !== true
  );
}

export function listShowsApprove(status: PhotoSubmissionStatus): boolean {
  return status === 'pending' || status === 'rejected';
}

export function listShowsReject(status: PhotoSubmissionStatus): boolean {
  return status === 'pending' || status === 'approved';
}
